import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_EQUIPOS,
  ALL_EQUIPOS,
  LOADING_ALL_EQUIPOS,
} from './EquiposReducer';
import {
  deleteEquiposService,
  allEquiposService,
  oneEquiposService,
  saveEquiposService,
} from './EquiposService';

export const allEquiposAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_EQUIPOS, payload: true });
    const res = await allEquiposService(params);
    dispatch({ type: ALL_EQUIPOS, payload: res.data });
    dispatch({ type: LOADING_ALL_EQUIPOS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_EQUIPOS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveEquiposAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveEquiposService(id, data);
    notify(res.data.message);
    await allEquiposAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoEquiposAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_EQUIPOS, payload: data });
};

export const oneEquiposAction = async (dispatch, id) => {
  try {
    const res = await oneEquiposService(id);
    await setActivoEquiposAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteEquiposAction = async ({ dispatch, notify }, id, params) => {
  try {
    const res = await deleteEquiposService(id);
    notify(res.data.message);
    await setActivoEquiposAction(dispatch, null);
    await allEquiposAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
